<template>
  <img :src="localeMap.src" width="526" height="528" />
</template>

<script setup>
import mapDePng from './images/map-de.png'
import mapAuPng from './images/map-au.png'
import mapUkPng from './images/map-uk.png'
import mapIePng from './images/map-ie.png'
import mapNzPng from './images/map-nz.png'
import mapUsPng from './images/map-us.png'
import mapBePng from './images/map-be.png'
import mapNlPng from './images/map-nl.png'

const localeMaps = {
  'de-DE': mapDePng,
  'en-AU': mapAuPng,
  'en-GB': mapUkPng,
  'en-IE': mapIePng,
  'en-NZ': mapNzPng,
  'en-US': mapUsPng,
  'nl-BE': mapBePng,
  'nl-NL': mapNlPng,
}

const { locale } = defineProps({ locale: String })
const localeMap = localeMaps[locale]
</script>
